import { render, staticRenderFns } from "./WristbandEventList.vue?vue&type=template&id=c376a4e6"
import script from "./WristbandEventList.vue?vue&type=script&lang=js"
export * from "./WristbandEventList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports